export const urlgetStuInfo =  '/common/InfoData/getStuInfo';
export const urlreviseStudent = '/common/InfoData/reviseStudent';
export const urlrevisePassword = '/common/InfoData/revisePassword';
export const urlgetTecInfo = '/common/InfoData/getTecInfo';
export const urlreviseTeacher = '/common/InfoData/reviseTeacher';
export const urlsaveAvatorUrl = '/common/InfoData/saveAvatorUrl';
export const urlsaveCoverUrl = '/common/InfoData/saveCoverUrl';
export const urlgetSchoolInfo = '/common/InfoData/getSchoolInfo';
export const urlsaveSchoolLogoUrl = '/common/InfoData/saveSchoolLogoUrl';

export const urlUpdateTeacherHomeWorkUrl = '/design/Course/UpdateTeacherHomeWorkUrl';
export const urlgetTeachIdentification = '/design/Course/getTeachIdentification';

import http from 'lib//http';

export interface IStuDataList {
    code: number;
    list: {
        Id: string;
        studentDisplayName: string;
        studyNumber: string;
        mobile: string;
        gender: string;
        WeChatNum: string;
        Wxnickname: string;
        AvatorUrl: string;
        description: string;
        affUnit: string;
        Password: string
    }[];
}

export function getStuInfo(id: string, mobile: string, gender: string, weChatNum: string, description: string,affUnit: string) {
    return http.post<IStuDataList>(urlgetStuInfo, {
         id,
         mobile,
         gender,
         weChatNum,
         description,
         affUnit,
    });
}

export function ReviseStudent(Id: string, mobile: string, gender: string, WeChatNum: string, description: string,affUnit: string,idCard?: string ) {
    return http.post<{ code: string, msg: string }>(urlreviseStudent, {
        Id,
        mobile,
        gender,
        WeChatNum,
        description,
        affUnit,
        idCard
    });
}

export interface IsaveAvatorUrl {
    code: number;
    Id: string;
    AvatorUrl: string;
}

export function saveAvatorUrl(Id: string, AvatorUrl?: string) {
    return http.post(urlsaveAvatorUrl, {
        Id,
        AvatorUrl
    });
}

export function RevisePassword(Id: string , Password: string, oldPassword: string) {
    return http.post<{code: string, msg: string}>(urlrevisePassword, {
        Id,
        Password,
        oldPassword
    });
}

export interface ITecDataList {
    code: number;
    list: {
        Id: string;
        TeacherDisplayName: string;
        TeacherUserName: string;
        Mobile: string;
        Gender: string;
        Description: string;
        Password: string;
        WeChatNum: string;
        Wxnickname: string;
        AvatorUrl: string;
    }[];
}

export function getTecInfo(Id: string, Mobile: string, Gender: string, WeChatNum: string, Description: string) {
 return http.post<ITecDataList>(urlgetTecInfo, {
        Id,
        Mobile,
        Gender,
        WeChatNum,
        Description
 });
}

export function ReviseTeacher(Id: string, Gender: string, WeChatNum: string, Description: string) {
    return http.post<{code: string, msg: string}>(urlreviseTeacher, {
        Id,
        Gender,
        WeChatNum,
        Description
    });
}

export function saveCoverUrl(Id: string, CoverUrl?: string) {
    return http.post<ITecDataList>(urlsaveCoverUrl, {
        Id,
        CoverUrl
    });
}

export interface ISchoolDataList {
     code: number;
     list: {
         Id: string;
         CreateDisplayName: string;
         SchoolName: string;
         SchoolType: string;
         ContactInformation: string;
         SchoolProvince: string;
         SchoolLogoUrl: string
     }[];
     userId: string;
}

export function getSchoolInfo(Id: string) {
    return http.post<ISchoolDataList>(urlgetSchoolInfo, {
        Id
    });
}

export function saveSchoolLogoUrl(Id: string, SchoolLogoUrl?: string) {
    return http.post<ISchoolDataList>(urlsaveSchoolLogoUrl, {
        Id,
        SchoolLogoUrl
    });
}

export const urlChangeTaskState = '/common/TaskState/ChangeTaskState';

export function ChangeTaskState(faceId: string) {
    return http.post(urlChangeTaskState, {
       faceId
    });
}

export const urlReleaseWX = '/common/InfoData/ReleaseWX';

export function ReleaseWX(oldPassword: string) {
    return http.post(urlReleaseWX, {
        oldPassword
    });
}

/*访客端与学生端公共接口方法*/
export const urlgetChapterOnlineQuestionList = '/common/ChapterOnlinePaper/getChapterOnlineQuestionList';

export interface IChapterQuestionList {
    code: number;
    msg: string;
    list: {
        SubId: string;
        SubContent: string;
        SubContentText: string;
        SubSelects: string;
        SubSortOrder: string;
        QuestionType: number;
        ParentQuestionId: string;
        SubScore: string;
    }[];
    paperName: string;
}

export function getChapterQuestionList(paperId: string) {
    return http.post<IChapterQuestionList>(urlgetChapterOnlineQuestionList, {
        paperId
    });
}

export interface IupdateTeacherHomeWorkUrl {
    code: number;
    msg: string;
}

export function updateTeacherHomeWorkUrl(Identification: string) {
    return http.post<IupdateTeacherHomeWorkUrl>(urlUpdateTeacherHomeWorkUrl, {
        Identification
    });
}

export interface IgetTeachIdentification {
    code: number;
    msg: string;
    Identification: string;
}

export function getTeachIdentification() {
    return http.post<IgetTeachIdentification>(urlgetTeachIdentification, {
    });
}

export const urlbindCellPhoneNumber = '/XOrg/AOrgInfo/bindCellPhoneNumber';

export function bindCellPhoneNumber(phoneNum: string, shortMessage: string , verifyCode: string) {
    return http.post<{code: number; msg: string}>(urlbindCellPhoneNumber, {
        phoneNum,
        shortMessage,
        verifyCode
    });
}

export const urlbindPhoneAfter = '/XOrg/AOrgInfo/bindPhoneAfter';

export function bindPhoneAfter(phoneNum: string) {
    return http.post<{code: number; msg: string}>(urlbindPhoneAfter, {
        phoneNum
    });
}
